var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('colorPick',{attrs:{"theme":"light","color":_vm.defaultColor,"sucker-hide":true,"sucker-canvas":_vm.suckerCanvas,"sucker-area":_vm.suckerArea},on:{"changeColor":_vm.changeColor,"openSucker":_vm.openSucker}})}
var staticRenderFns = []

export { render, staticRenderFns }